function onDocumentReady() {
    jQuery(document).on('submit', '.search-form', onSearchSubmit);
}

function onSearchSubmit(e) {
    let form = jQuery(e.currentTarget);
    let input = form.find('[name="s"]').val();

    if (!input) {
        e.preventDefault();
        return false;
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
